import { Component, forwardRef, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'app-nz-date-range-picker',
    templateUrl: './nz-date-range-picker.component.html',
    styleUrls: ['./nz-date-range-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NzDateRangePickerComponent),
            multi: true,
        },
    ],
})
export class NzDateRangePickerComponent implements ControlValueAccessor, OnInit, OnDestroy {
    @Input() nzDisabledDate: (d: Date) => boolean = () => false;
    @Input() nzFormat = 'yyyy-MM-dd';
    @Input() nzDropdownClassName = '';
    @Input() placeholder = 'Select date range';
    @Input() title = '';
    @Input() confirmLabel = 'Confirm';
    @Input() cancelLabel = 'Cancel';
    @Input() clearLabel = 'Clear';

    innerValue: Date[] = [];
    tempValue: Date[] = [];
    overlayVisible = false;
    isMobile = false;

    private onChange: (v: Date[]) => void = () => {};
    private onTouched: () => void = () => {};

    ngOnInit(): void {
        this.isMobile = window.innerWidth <= 767;
    }

    ngOnDestroy(): void {
        document.body.style.overflow = '';
    }

    @HostListener('window:resize')
    onResize(): void {
        this.isMobile = window.innerWidth <= 767;
    }

    writeValue(value: Date[]): void {
        this.innerValue = value ?? [];
    }

    registerOnChange(fn: (v: Date[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    get triggerLabel(): string {
        if (!this.innerValue?.length) return '';
        const fmt = (d: Date) => moment(d).format('YYYY-MM-DD');
        return `${fmt(this.innerValue[0])} → ${fmt(this.innerValue[1])}`;
    }

    openOverlay(): void {
        this.tempValue = [...(this.innerValue ?? [])];
        this.overlayVisible = true;
        document.body.style.overflow = 'hidden';
    }

    closeOverlay(): void {
        this.overlayVisible = false;
        document.body.style.overflow = '';
    }

    onBackdropClick(event: MouseEvent): void {
        if ((event.target as HTMLElement).classList.contains('drp-overlay')) {
            this.closeOverlay();
        }
    }

    onConfirm(): void {
        this.innerValue = [...this.tempValue];
        this.onChange(this.innerValue);
        this.onTouched();
        this.closeOverlay();
    }

    onCancel(): void {
        this.closeOverlay();
    }

    onClear(): void {
        this.tempValue = [];
    }

    onDesktopChange(dates: Date[]): void {
        this.innerValue = dates ?? [];
        this.onChange(this.innerValue);
        this.onTouched();
    }
}
